'use strict';

require('./impromptu');

let form = require('../form/form');
import Trackers from '../tracker/tracker';
import Events from '../../blocks/tracker/events';

const trackers = new Trackers();

$(function() {
    const validateParams = Object.assign({}, form.formValidateDefaults, {
        rules: {
            NAME: {
                required: true
            },
            EMAIL: {
                required: true,
                email: true,
                remote: {
                    url: '/ajax/action/order_oneclick/check_user_person_type/',
                    type: 'post',
                    dataType: 'json',
                    dataFilter: response => {
                        let result = false;

                        response = JSON.parse(response);
                        if (response.data.hasOwnProperty('is_opt')) {
                            result = !response.data.is_opt;
                        }

                        return result;
                    }
                }
            },
            PHONE: {
                required: true,
                phoneMask: true
            }
        },
        messages: {
            NAME: {
                required: $.validator.messages.NAME.required
            },
            EMAIL: {
                required: $.validator.messages.EMAIL.required,
                remote: $.validator.messages.EMAIL.remote
            },
            PHONE: {
                required: $.validator.messages.PHONE.required,
                phoneMask: $.validator.messages.PHONE.phoneMask
            }
        },
        submitHandler: form => {
            const params = $(form).serializeObject();

            params.products = [
                {
                    id: document.querySelector('.js-one-click').dataset.productId,
                    quantity: 1
                }
            ];

            $(form)
                .find('button[type="submit"]')
                .prop('disabled', true);

            oneClickBuy(params).done(function() {
                $(form)
                    .find('button[type="submit"]')
                    .prop('disabled', false);
            });
        }
    });

    function oneClickBuy(params) {
        return $.post(
            '/ajax/action/order_oneclick/buy/',
            params,
            response => {
                if (response.code >= 200 && response.code < 300) {
                    showSuccess(response.data.success);
                    trackers.onOneClickBuyEnd({
                        fbpixel: {
                            value: parseInt(
                                document.querySelector('.product-card__price-value').textContent.replace(' ', '')
                            )
                        }
                    });
                } else if (response.data.error) {
                    showError(response.data.error);
                } else {
                    showError('Ошибка создания заказа, пожалуйста перезагрузите страницу!');
                }
            },
            'json'
        );
    }

    function showSuccess(message) {
        if (popup) {
            popup.close();
        }
        let list = document.getElementsByClassName('breadcrumbs__text');
        let ierarhy = [];

        for (let item of list) {
            ierarhy.push(item.innerHTML);
        }

        let category = ierarhy.slice(2,-1).join('/');
        let name = ierarhy.slice(-1)[0];
        trackers.onPMfrm1Click({param1:category, param2:name});
        new Impromptu(message, {
            buttons: {},
            persistent: false,
            close: event => {
                event.preventDefault();
                document.location.reload('/');
            }
        });
    }

    function showError(error) {
        error = error.join('<br>');
        $('.js-oneclick_error').html(error);
    }

    let popupHtml = '';
    let popup = null;

    function showPopup(popupHtml) {
        return new Impromptu(popupHtml, {
            buttons: {},
            persistent: false,
            submit: (event, value, message) => {
                const form = message.closest('form');

                /** revalidate */
                if (form.data('validator')) {
                    form.data('validator').destroy();
                }
                form.validate(
                    Object.assign({}, validateParams, {
                        submitHandler: form => {
                            const params = $(form).serializeObject();

                            params.products = [
                                {
                                    id: document.querySelector('.js-one-click').dataset.productId,
                                    quantity: 1
                                }
                            ];

                            $(form)
                                .find('button[type="submit"]')
                                .prop('disabled', true);

                            oneClickBuy(params).done(function() {
                                $(form)
                                    .find('button[type="submit"]')
                                    .prop('disabled', false);
                            });
                        }
                    })
                );

                event.preventDefault();
            }
        });
    }

    /**
     * На карточке товара
     */
    $('body').on('click', '.js-one-click', event => {
        event.preventDefault();
        trackers.onOneClickBuyButton();
        if (popupHtml == '') {
            $.ajax({
                url: '/ajax/component/maximaster:order.oneclick/popup/',
                success: result => {
                    popupHtml = result.html;
                    popup = showPopup(popupHtml);
                    let list = document.getElementsByClassName('breadcrumbs__text');
                    let ierarhy = [];

                    for (let item of list) {
                        ierarhy.push(item.innerHTML);
                    }

                    let category = ierarhy.slice(2,-1).join('/');
                    let name = ierarhy.slice(-1)[0];
                    trackers.onPMbtn1Click({param1:category, param2:name});
                }
            });
        } else {
            popup = showPopup(popupHtml);
        }
    });

    /**
     * В оформлении заказа
     */
    if ($('div.checkout').length > 0) {
        $('.js-oneclick-component > form').validate(
            Object.assign({}, validateParams, {
                submitHandler: form => {
                    const params = $(form).serializeObject();
                    let ev = new Events();

                    $(form)
                        .find('button[type="submit"]')
                        .prop('disabled', true);

                    ev.onShowOrderStep(2);
                    ev.onShowOrderStep(3);
                    trackers.onOneClickBuyEnd({
                        fbpixel: {
                            value: parseInt(
                                document.querySelector('.cart-total__line-value--main').textContent.replace(' ', '')
                            )
                        }
                    });

                    oneClickBuy(params).done(function() {
                        $(form)
                            .find('button[type="submit"]')
                            .prop('disabled', false);
                    });
                }
            })
        );
    }
});



// WEBPACK FOOTER //
// ./blocks/impromptu/impromptu-one-click.js